var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"id":"text-input-hp2i4u","label":_vm.properties.label}},[_c('b-input',{attrs:{"id":"text-input-9s5ilh","min":_vm.minValue,"size":"sm","type":_vm.properties.type ? _vm.properties.type : 'text'},model:{value:(_vm.propertyValue),callback:function ($$v) {_vm.propertyValue=$$v},expression:"propertyValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }